import DOMPurify from 'dompurify';
import type { Config as DOMPurifyConfig } from 'dompurify';
import { isString } from '@/domain/utils/TypePredicates';

const sanitiseHTML = (input: unknown, config: DOMPurifyConfig = {}): string => {
	const htmlString = isString(input) ? input : String(input);
	return DOMPurify.sanitize(htmlString, config);
};

export { sanitiseHTML };
